import BaseRequest from '@/qingyu/request/base'
import { config } from '@/qingyu'

/**
 * 服务相关API请求类
 */
export default class ServiceRequest extends BaseRequest {
  /**
   * 提交物业报修申请
   * @param {Object} data - 报修数据
   * @returns {Promise} 返回提交结果
   */
  submitRepair(data) {
    return this.post(config.api.ENTERPRISE.REPAIR_ADD, data);
  }

  /**
   * 获取物业报修列表
   * @param {Object} params - 查询参数
   * @returns {Promise} 返回报修列表
   */
  getRepairList(params) {
    return this.post(config.api.ENTERPRISE.REPAIR_LIST_NEW, params);
  }

  /**
   * 获取可报修园区列表
   * @returns {Promise} 返回可报修园区列表
   */
  getValidParks() {
    return this.post(config.api.ENTERPRISE.GET_VALID_PARKS);
  }

  /**
   * 获取物业报修历史记录
   * @param {Object} params - 查询参数
   * @returns {Promise} 返回报修历史记录
   */
  getRepairHistory(params) {
    return this.get('/api/service/repair/history', params);
  }

  /**
   * 获取物业报修详情
   * @param {string} id - 报修ID
   * @returns {Promise} 返回报修详情
   */
  getRepairDetail(id) {
    return this.get(`/api/service/repair/detail/${id}`);
  }

  /**
   * 取消物业报修申请
   * @param {string} id - 报修ID
   * @returns {Promise} 返回取消结果
   */
  cancelRepair(id) {
    return this.post(`/api/service/repair/cancel/${id}`);
  }

  /**
   * 评价物业报修服务
   * @param {string} id - 报修ID
   * @param {Object} data - 评价数据
   * @returns {Promise} 返回评价结果
   */
  rateRepairService(id, data) {
    return this.post(`/api/service/repair/rate/${id}`, data);
  }

  /**
   * 提交访客预约
   * @param {Object} data - 预约数据
   * @returns {Promise} 返回提交结果
   */
  submitVisitorAppointment(data) {
    return this.post('/api/service/visitor/submit', data);
  }

  /**
   * 获取访客预约历史记录
   * @param {Object} params - 查询参数
   * @returns {Promise} 返回预约历史记录
   */
  getVisitorHistory(params) {
    return this.get('/api/service/visitor/history', params);
  }

  /**
   * 取消访客预约
   * @param {string} id - 预约ID
   * @returns {Promise} 返回取消结果
   */
  cancelVisitorAppointment(id) {
    return this.post(`/api/service/visitor/cancel/${id}`);
  }

  /**
   * 提交设施预约
   * @param {Object} data - 预约数据
   * @returns {Promise} 返回提交结果
   */
  submitFacilityReservation(data) {
    return this.post('/api/service/facility/submit', data);
  }

  /**
   * 获取设施预约历史记录
   * @param {Object} params - 查询参数
   * @returns {Promise} 返回预约历史记录
   */
  getFacilityHistory(params) {
    return this.get('/api/service/facility/history', params);
  }

  /**
   * 取消设施预约
   * @param {string} id - 预约ID
   * @returns {Promise} 返回取消结果
   */
  cancelFacilityReservation(id) {
    return this.post(`/api/service/facility/cancel/${id}`);
  }

  /**
   * 获取设施列表
   * @param {Object} params - 查询参数
   * @returns {Promise} 返回设施列表
   */
  getFacilityList(params) {
    return this.get('/api/service/facility/list', params);
  }

  /**
   * 获取通知公告列表
   * @param {Object} params - 查询参数
   * @returns {Promise} 返回通知公告列表
   */
  getAnnouncementList(params) {
    return this.get('/api/service/announcement/list', params);
  }

  /**
   * 获取通知公告详情
   * @param {string} id - 通知ID
   * @returns {Promise} 返回通知详情
   */
  getAnnouncementDetail(id) {
    return this.get(`/api/service/announcement/detail/${id}`);
  }

  /**
   * 标记通知已读
   * @param {string} id - 通知ID
   * @returns {Promise} 返回标记结果
   */
  markAnnouncementRead(id) {
    return this.post(`/api/service/announcement/read/${id}`);
  }

  /**
   * 获取人才服务配置
   * @returns {Promise} 返回人才服务配置信息
   */
  getTalentServiceConfig() {
    return this.post(config.api.ENTERPRISE.TALENT_SERVICE_LIST);
  }

  // 获取信息提报列表
  getTibaoList(params = {}) {
    return this.post('/api/v1/entser/gettibaolist', params)
  }

  // 获取信息提报详情
  getTibaoDetail(id) {
    return this.post('/api/v1/entser/gettibaodetail', { id })
  }

  // 提交信息提报
  submitTibao(data) {
    return this.post('/api/v1/entser/tibao', data)
  }

  // 获取提报记录
  getTibaoData(params) {
    return this.post('/api/v1/entser/gettibaodata', params)
  }

  // 更新提报记录
  updateTibao(params) {
    return this.post('/api/v1/entser/tibaoupdate', params)
  }

  // 获取控制台数据
  getConsoleData() {
    return this.post('/api/v1/entser/consoledata')
  }

  // 获取专利列表
  getZhuanliList(params) {
    return this.post('/api/v1/entser/getzhuanlilist', params)
  }

  // 获取专利详情
  getZhuanliDetail(id) {
    return this.post('/api/v1/entser/getzhuanlidetail', { id })
  }

  // 获取软著列表
  getRuanzhuList(params) {
    return this.post('/api/v1/entser/getruanzhulist', params)
  }

  // 获取软著详情
  getRuanzhuDetail(id) {
    return this.post('/api/v1/entser/getruanzhudetail', { id })
  }

  // 获取企业经营信息列表
  getCompanyYuebaoList(params) {
    return this.post('/api/v1/entser/getcompanyyuebaolist', params)
  }

  // 提交企业经营信息
  addCompanyYuebao(data) {
    return this.post('/api/v1/entser/addcompanyyuebao', data)
  }

  // 获取企业经营信息详情
  getCompanyYuebaoDetail(params) {
    return this.post('/api/v1/entser/getcompanyyuebaodetail', params)
  }

  // 更新企业经营信息
  updateCompanyYuebao(data) {
    return this.post('/api/v1/entser/companyyuebaoupdate', data)
  }
}

export const serviceRequest = new ServiceRequest() 